<template>
 <div id="g-page" >

  <table id="main-table-screen" border="0">
    <tr>
      <td id="main-table-row1" colspan="1"> 
      </td>
    </tr>

    <tr>
      <td id="main-table-row2-dialog-container-td">

        <table class="dialog-table" align="center" border="0">
          <tr>
            <td id="dialog-td-title" class="radius-single-left-field-left-top radius-single-left-field-left-bottom radius-single-right-field-right-top radius-single-right-field-right-bottom" >
                <p class="wrap">{{ $t("db.title1") }}</p> <!--Engage for Members - Medical Portal-->
                <div style="height:5px" />
                <img src="../../assets/images/ehe_logo.png" style="width:110px">
            </td>
          </tr>
        </table>
        
        <table class="dialog-table" align="center" border="0">
          <!-- 
            *************************************
            *               WELCOME             *
            *************************************
          -->
          <div style="height:10px;"></div>
          <tr colspan="3">
            <td class="dialog-signon-td-section-title radius-top-left-field-top radius-top-left-field-bottom radius-top-right-field-top radius-top-right-field-bottom" colspan="3">
              <p>{{ $t("db.welcomeHeader") }}</p><!--WELCOME-->
            </td>
          </tr>
          <tr>
            <td class="dialog-question-space" colspan="1">
              <div style="height:20px" />
            </td>
          </tr>
          <tr>
            <!-- ENTRY WELCOME -->
            <td class="entry" colspan="1">
              {{ $t("db.welcomeStatement") }}
              <!--Welecome to the Engage for Members patient portal. Here you can view your appointments, keep your medical history up to date, view your medical test results, search for medical providers and locate consent forms at your convenience, 24/7.-->
            </td>
          </tr>

          <tr>
            <td colspan="1" class="radius-bottom-left-field-top radius-bottom-left-field-bottom radius-bottom-right-field-top radius-bottom-right-field-bottom" style="background-color:#343F68">
              <div style="height:15px;"></div>
            </td>
          </tr>
        </table>

        <!-- 
          *************************************
          *              ENTRIES              *
          *************************************
        -->
        <table class="dialog-table" align="center" border="0">
           <!-- ENTRY ROW 0 -->
          <tr>
            <!-- ENTRY FIT FOR DUTY QUESTIONNAIRE -->
            <td class="dialog-table-half-width">
              <table class="dialog-table-half-l" align="center" border="0">
                <!-- 
                  *************************************
                  *    FIT FOR DUTY QUESTIONNAIRE    *
                  *************************************
                -->
                <div style="height:10px;"></div>
                <tr colspan="1">
                  <td class="dialog-signon-td-section-title radius-top-left-field-top radius-top-left-field-bottom radius-top-right-field-top radius-top-right-field-bottom" colspan="3">
                    <p>FITNESS FOR DUTY QUESTIONNAIRE</p><!--FITNESS FOR DUTY QUESTIONNAIRE-->
                  </td>
                </tr>
                <tr>
                  <td class="dialog-question-space" colspan="1">
                    <div style="height:20px" />
                  </td>
                </tr>
                <tr>
                  <!-- ENTRY FIT FOR DUTY QUESTIONNAIRE -->
                  <td class="entry" colspan="1">
                    <div class="statement">
                      {{ $t("db.ffdStatement1") }}
                      <span class="toggleBreak"><br></span>
                      {{ $t("db.ffdStatement2") }}
                      <!--If you have been asked to fill out a Fitness For Duty Daily Questionnaire then click here to get started.-->
                      <br><br>
                    </div>
                    <input type="button" 
                      class="dialog-input-button" 
                      v-on:click="goto('/members/daily-questionnaire')" 
                      v-bind:value="$t('db.ffdButton')"><!--  Fitness for Duty Daily Questionnaire-->
                  </td>
                </tr>

                <tr>
                  <td colspan="1" class="radius-bottom-left-field-top radius-bottom-left-field-bottom radius-bottom-right-field-top radius-bottom-right-field-bottom" style="background-color:#343F68">
                    <div style="height:15px;"></div>
                  </td>
                </tr>
              </table>
            </td>
            <!-- ENTRY COVID-19 QUESTIONNAIRE -->
            <td class="dialog-table-half-width">
              <table class="dialog-table-half-r" align="center" border="0">
                <!-- 
                  *************************************
                  *        COVID-19 QUESTIONNAIRE     *
                  *************************************
                -->
                <div style="height:10px;"></div>
                <tr colspan="1">
                  <td class="dialog-signon-td-section-title radius-top-left-field-top radius-top-left-field-bottom radius-top-right-field-top radius-top-right-field-bottom" colspan="3">
                    <p>{{ $t("db.c19Header") }}</p><!--COVID-19 QUESTIONNAIRE-->
                  </td>
                </tr>
                <tr>
                  <td class="dialog-question-space" colspan="3">
                    <div style="height:20px" />
                  </td>
                </tr>
                <tr>
                  <!-- ENTRY DAILY QUESTIONNAIRE -->
                  <td class="entry" colspan="1">
                  <!-- ENTRY DAILY QUESTIONNAIRE -->
                    <div class="statement">
                      {{ $t("db.c19Statement1") }}
                      <span class="toggleBreak"><br></span>
                      {{ $t("db.c19Statement2") }}
                      <!-- If you have been asked to fill out a COVID-19 Daily Questionnaire then click here to get started.-->
                      <br><br>
                    </div>
                    <input type="button" 
                      class="dialog-input-button" 
                      v-on:click="goto('/members/c19-daily-questionnaire')" 
                      v-bind:value="$t('db.c19Button')"><!-- COVID-19 Daily Questionnaire-->
                  </td>
                </tr>

                <tr>
                  <td colspan="1" class="radius-bottom-left-field-top radius-bottom-left-field-bottom radius-bottom-right-field-top radius-bottom-right-field-bottom" style="background-color:#343F68">
                    <div style="height:15px;"></div>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
          <!-- ENTRY ROW 1 -->
          <tr>
            <!-- ENTRY MEDICAL HISTORY -->
            <td class="dialog-table-half-width">
              <table class="dialog-table-half-l" align="center" border="0">
                <!-- 
                  *************************************
                  *      MEDICAL APPOINTMENTS         *
                  *************************************
                -->
                <div style="height:10px;"></div>
                <tr colspan="1">
                  <td class="dialog-signon-td-section-title radius-top-left-field-top radius-top-left-field-bottom radius-top-right-field-top radius-top-right-field-bottom" colspan="3">
                    <p>{{ $t("db.maHeader")}}</p><!--MEDICAL APPOINTMENTS-->
                  </td>
                </tr>
                <tr>
                  <td class="dialog-question-space" colspan="1">
                    <div style="height:20px" />
                  </td>
                </tr>
                <tr>
                  <!-- ENTRY MEDICAL APPOINTMENTS -->
                  <td class="entry" colspan="1">
                    <div class="statement">
                      {{ $t("db.maStatement1") }}
                      <span class="toggleBreak"><br></span>
                      {{ $t("db.maStatement2") }}
                      <!-- View your current and past medical appointment appointment history here. -->
                      <br><br>
                    </div>
                    <input type="button" 
                      class="dialog-input-button" 
                      v-on:click="goto('/members/appointments')" 
                      v-bind:value="$t('db.maButton')"><!--View My Medical Appointments-->
                  </td>
                </tr>

                <tr>
                  <td colspan="1" class="radius-bottom-left-field-top radius-bottom-left-field-bottom radius-bottom-right-field-top radius-bottom-right-field-bottom" style="background-color:#343F68">
                    <div style="height:15px;"></div>
                  </td>
                </tr>
              </table>
            </td>
            <!-- ENTRY MEDICAL TEST RESULTS -->
            <td class="dialog-table-half-width">
              <table class="dialog-table-half-r" align="center" border="0">
                <!-- 
                  *************************************
                  *        MEDICAL TEST RESULTS       *
                  *************************************
                -->
                <div style="height:10px;"></div>
                <tr colspan="1">
                  <td class="dialog-signon-td-section-title radius-top-left-field-top radius-top-left-field-bottom radius-top-right-field-top radius-top-right-field-bottom" colspan="3">
                    <p>{{ $t("db.mtrHeader") }} </p><!-- MEDICAL TEST RESULTS-->
                  </td>
                </tr>
                <tr>
                  <td class="dialog-question-space" colspan="3">
                    <div style="height:20px" />
                  </td>
                </tr>
                <tr>
                  <!-- ENTRY MEDICAL TEST RESULTS -->
                  <td class="entry" colspan="1">
                  <!-- ENTRY MEDICAL HISTORY -->
                    <div class="statement">
                      {{ $t("db.mtrStatement1") }}
                      <span class="toggleBreak"><br></span>
                      {{ $t("db.mtrStatement2") }}
                      <!--Find out your test results the moment they are recorded by your physician.-->
                      <br><br>
                    </div>
                    <input type="button" 
                      class="dialog-input-button" 
                      v-on:click="goto('/members/medical-tests')" 
                      v-bind:value="$t('db.mtrButton')"><!--Review My Medical Test Results-->
                  </td>
                </tr>

                <tr>
                  <td colspan="1" class="radius-bottom-left-field-top radius-bottom-left-field-bottom radius-bottom-right-field-top radius-bottom-right-field-bottom" style="background-color:#343F68">
                    <div style="height:15px;"></div>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
          <!-- ENTRY ROW 2 -->
          <tr>
            <!-- ENTRY PROVIDERS -->
            <td class="dialog-table-half-width">
              <table class="dialog-table-half-l" align="center" border="0">
                <!-- 
                  *************************************
                  *           MEDICAL HISTORY         *
                  *************************************
                -->
                <div style="height:10px;"></div>
                <tr colspan="1">
                  <td class="dialog-signon-td-section-title radius-top-left-field-top radius-top-left-field-bottom radius-top-right-field-top radius-top-right-field-bottom" colspan="3">
                    <p>{{ $t("db.mhHeader")}}</p><!--MEDICAL HISTORY-->
                  </td>
                </tr>
                <tr>
                  <td class="dialog-question-space" colspan="1">
                    <div style="height:20px" />
                  </td>
                </tr>
                <tr>
                  <!-- ENTRY MEDICAL HISTORY -->
                  <td class="entry" colspan="1">
                    <div class="statement">
                      {{ $t("db.mhStatement1") }}
                      <span class="toggleBreak"><br></span>
                      {{ $t("db.mhStatement2") }}
                      <!-- Before you go to your appointment, make sure that your medical history is up to date here. -->
                      <br><br>
                    </div>
                    <input type="button" 
                      class="dialog-input-button" 
                      v-on:click="goto('/members/my-medical-history')" 
                      v-bind:value="$t('db.mhButton')"><!--Enter / Update My Medical History-->
                  </td>
                </tr>

                <tr>
                  <td colspan="1" class="radius-bottom-left-field-top radius-bottom-left-field-bottom radius-bottom-right-field-top radius-bottom-right-field-bottom" style="background-color:#343F68">
                    <div style="height:15px;"></div>
                  </td>
                </tr>
              </table>
            </td>
             <!-- ENTRY PROVIDERS -->
            <td class="dialog-table-half-width">
              <table class="dialog-table-half-r" align="center" border="0">
                <!-- 
                  *************************************
                  *             PROVIDERS             *
                  *************************************
                -->
                <div style="height:10px;"></div>
                <tr colspan="1">
                  <td class="dialog-signon-td-section-title radius-top-left-field-top radius-top-left-field-bottom radius-top-right-field-top radius-top-right-field-bottom" colspan="3">
                    <p>{{ $t("db.prHeader")}}</p><!--PROVIDERS-->
                  </td>
                </tr>
                <tr>
                  <td class="dialog-question-space" colspan="3">
                    <div style="height:20px" />
                  </td>
                </tr>
                <tr>
                  <!-- ENTRY PROVIDERS -->
                  <td class="entry" colspan="1">
                    <!-- ENTRY PROVIDERS -->
                    <div class="statement">
                      {{ $t("db.prStatement1") }}
                      <span class="toggleBreak"><br></span>
                      {{ $t("db.prStatement2") }}
                      <!--View your current providers or search the Engage medical network for a provider you wish to see.-->
                      <br><br>
                    </div>
                    <input type="button" 
                      class="dialog-input-button" 
                      v-on:click="goto('/members/my-physicians')" 
                      v-bind:value="$t('db.prButton')"><!--View / Modify My Provider Practice Participation-->
                  </td>
                </tr>

                <tr>
                  <td colspan="1" class="radius-bottom-left-field-top radius-bottom-left-field-bottom radius-bottom-right-field-top radius-bottom-right-field-bottom" style="background-color:#343F68">
                    <div style="height:15px;"></div>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
          <!-- ENTRY ROW 3 -->
          <tr>
            <!-- ENTRY OPTIONAL CONSENTS -->
            <td class="dialog-table-half-width">
              <table class="dialog-table-half-l" align="center" border="0">
                <!-- 
                  *************************************
                  *           OPTIONAL CONSENTS       *
                  *************************************
                -->
                <div style="height:10px;"></div>
                <tr colspan="1">
                  <td class="dialog-signon-td-section-title radius-top-left-field-top radius-top-left-field-bottom radius-top-right-field-top radius-top-right-field-bottom" colspan="3">
                    <p>{{ $t("db.ocHeader") }}</p><!--OPTIONAL CONSENTS-->
                  </td>
                </tr>
                <tr>
                  <td class="dialog-question-space" colspan="1">
                    <div style="height:20px" />
                  </td>
                </tr>
                <tr>
                  <!-- ENTRY OPTIONAL CONSENTS -->
                  <td class="entry" colspan="1">
                    <div class="statement">
                      {{ $t("db.ocStatement1") }}
                      <span class="toggleBreak"><br></span>
                      {{ $t("db.ocStatement2") }}
                      <!--Access the consent that you have been asked to fill out.-->
                      <br><br>
                    </div>
                    <input type="button" 
                      class="dialog-input-button" 
                      v-on:click="goto('/consent/optional')" 
                      v-bind:value="$t('db.mtrButton')"><!--Optional Consents-->
                  </td>
                </tr>

                <tr>
                  <td colspan="1" class="radius-bottom-left-field-top radius-bottom-left-field-bottom radius-bottom-right-field-top radius-bottom-right-field-bottom" style="background-color:#343F68">
                    <div style="height:15px;"></div>
                  </td>
                </tr>
              </table>
            </td>
            <!-- LOGOFF -->
            <td class="dialog-table-half-width">
              <table class="dialog-table-half-r" align="center" border="0">
                <!-- 
                  *************************************
                  *             LOGOFF                *
                  *************************************
                -->
                <div style="height:10px;"></div>
                <tr colspan="1">
                  <td class="dialog-signon-td-section-title radius-top-left-field-top radius-top-left-field-bottom radius-top-right-field-top radius-top-right-field-bottom" colspan="3">
                    <p>{{ $t("db.loHeader")}}</p><!--LOGOFF-->
                  </td>
                </tr>
                <tr>
                  <td class="dialog-question-space" colspan="3">
                    <div style="height:20px" />
                  </td>
                </tr>
                <tr>
                  <!-- ENTRY LOGOFF -->
                  <td class="entry" colspan="1">
                    <!-- ENTRY LOGOFF -->
                    <div class="statement">
                      {{ $t("db.loStatement1") }}
                      <span class="toggleBreak"><br></span>
                      {{ $t("db.loStatement2") }}
                      <!--Signoff and end your online medical session here.-->
                      <br><br>
                    </div>
                    <input type="button" 
                      class="dialog-input-button" 
                      v-on:click="logoff()" 
                      v-bind:value="$t('db.loButton')"><!--Logoff-->
                  </td>
                </tr>

                <tr>
                  <td colspan="1" class="radius-bottom-left-field-top radius-bottom-left-field-bottom radius-bottom-right-field-top radius-bottom-right-field-bottom" style="background-color:#343F68">
                    <div style="height:15px;"></div>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
         
        </table>

        <table class="dialog-table" align="center" border="0">
          <!-- 
            *************************************
            *               NOTICE             *
            *************************************
          -->
          <div style="height:10px;"></div>
          <tr colspan="3">
            <td class="dialog-signon-td-section-title radius-top-left-field-top radius-top-left-field-bottom radius-top-right-field-top radius-top-right-field-bottom" colspan="3">
              <p>{{ $t("db.legalHeader")}}</p><!--NOTICE-->
            </td>
          </tr>
          <tr>
            <td class="dialog-question-space" colspan="1">
              <div style="height:20px" />
            </td>
          </tr>
          <tr>
            <!-- ENTRY NOTICE -->
            <td class="entry" colspan="1">
              <div style="width:100%">
                {{ $t("db.legalMsg")}}
                <!--This application contains confidential health information. The information is provided as is to the Engage account owner. As the Engage medical account owner you should maintain this information in safe and secure manner. This information should remain confidential. If you are not the intended recipient of this information, please immediately alert your provider immediately.-->
              </div>
            </td>
          </tr>

          <tr>
            <td colspan="1" class="radius-bottom-left-field-top radius-bottom-left-field-bottom radius-bottom-right-field-top radius-bottom-right-field-bottom" style="background-color:#343F68">
              <div style="height:15px;"></div>
            </td>
          </tr>
        </table>
      </td>
    </tr>
    
    <tr>
      <td id="main-table-row3" colspan="1" > 
      </td>
    </tr>
  </table>

  </div>
</template>

<script>
  //import { API } from '../../../api/member-api'
  const { API } = require( '../../api/member-api' + '?v=' + process.env.VUE_APP_VERSION )

  //import { SUPPORT } from '../../../api/member-api'
  const { SUPPORT } = require( '../../api/member-api' + '?v=' + process.env.VUE_APP_VERSION )

  import messageBox from './common/message-box'
  //import confirmBox from './c19/c19-confirm-box'
  //import moment from 'moment'

  export default 
  {
    name: 'daily-questionniare',
    mounted(){
      
      // SHOW TOP OF VIEW
      window.scrollTo(0, 0);

      this.load();
    },
    methods:
    {
      load()
      {
        try
        {
          if(window.sessionKey != '')
          {
            
            // CHANGE THE MENU FROM LOGON
            SUPPORT.showServiceMenus();
            document.getElementById('menuLogoff').classList.remove('is-hidden');
            document.getElementById('menuMember').innerHTML = '<span v-on:click="toggleMenus" style="white-space:pre">Hi ' + window.firstName + '</span>'
            document.getElementById('menuDashboard').classList.add('is-hidden');
          } 
        }
        catch(e)
        {
          this.$generalMessage( messageBox, e );
        }
      },
      logoff()
      {
        // LOG THE SESSION OUT HERE
        API.logoff(window.sessionKey);
        window.sessionKey = '';

        // REDIRECT TO THE HOME PAGE
        this.$router.push( { path: "/"} );
      },
      goto(target)
      {
        this.$router.push( { path: target} );
      }
    }
  }
</script>


<style lang="scss" scoped>
@import "../../assets/styles/global.css";

// DISABLE WIDESCREEN BREAKPOINT
$widescreen-enabled: false;

// DISABLE FULLHD BREAKPOINT
$fullhd-enabled: false;

// BEGIN SHARED STYLES
p {
  white-space: pre;
}
.disabled {
  background-color:darkgray;
}

.enabled {
  background-color: white;
}
// END SHARED STYLES

//////////////////////////////////////////
// MOBILE
@media only screen and 
(min-width : 320px) and (max-width : 1023px)
{
  // NOT WORKING
  /* @-ms-viewport{
    width: device-width;
  } */

  #main-table-screen
  {
    max-width: 100%;
    width:100%;
    background-color:gray;
    padding: 0px;
    margin: 0px;
    margin-bottom:15px;
    display:table;
  }
  #main-table-row1
  {
    height:15px; 
  }
  #main-table-row2-dialog-container-td
  {
    margin:auto;
  }

  // BEGIN TABLE STYLES
  table { // KEY, FIXES TABLE TO MOBILE WIDTH
    table-layout:fixed;
  }
  .dialog-table
  {
    width:96%;
  }
  .dialog-table-half-width
  {
    width:100%;
  }
  .dialog-table-half-l
  {
    width:100%;
  }
  .dialog-table-half-r
  {
    width:100%;
  }
  #dialog-td-title
  {
    width:100%;
    height:85px;
    background-color:#4682B4;
    color:white;
    font-family:'Arial Black';
    font-size: 17pt;
    font-style:italic;
    font-weight: bold;    
    padding-bottom:0px;
    margin-bottom:0px;
    vertical-align: middle;
    text-align: center;
  }
  #dialog-td-instructions
  {
    width:100%;
    word-wrap:break-word !important;
    background-color:#4682B4;
    color:white;
    font-family:'Arial';
    font-size: 11pt;
    font-style:italic;
    padding-left:10px;
    padding-right:10px;
    vertical-align: middle;
  }
  .dialog-signon-td-section-title
  {
    width:100%;
    height:47px;
    background-color:darkgray;//#4682B4;
    color:white;
    font-family:'Arial Black';
    font-size: 12pt;
    font-style:italic;
    font-weight: bold;
    padding-left:5px;
    padding-right:5px;
    padding-bottom:0px;
    margin-bottom:0px;
    vertical-align: bottom;
    text-align: center;
  }
  .dialog-question-space
  {
    width:0px;
    height:0px;
    background-color:#343F68;
    color:white;
  }
  .dialog-question-space-alt
  {
    width:0px;
    height:0px;
    background-color:#343F68;
    color:white;
  }
  .dialog-question
  {
    height:100%;
    width:100%;//300px;
    padding-left:5px;
    padding-right:5px;
    background-color:#343F68;
    color:white;
    word-wrap:break-word !important
  }
  .dialog-input-field-right
  {
    width:100%;
    height:auto; //25px;
    vertical-align: top;
    background-color:#343F68;
    color:white;
    text-align: right;
    padding-right:25px;
  }
  .dialog-input-field-right-alt
  {
    width:100%;
    height:25px;
    vertical-align: top;
    background-color:#343F68;
    color:white;
    text-align: right;
    padding-right:25px;
  }
  .dialog-sub-question 
  {
    padding-left:5px;
    padding-right:5px;
    background-color:#343F68;
    color:white;
    vertical-align:top;
  }
  .dialog-sub-question-alt
  {
    padding-left:5px;
    padding-right:5px;
    background-color:#343F68;
    color:white;
    vertical-align:top;
  }
   .dialog-sub-question-div
  {
    width:0px;
  }
  
  .dialog-input-field-explain
  {
    height:40px;
    vertical-align: middle;
    background-color:#343F68;
    color:white;
    padding-left:5px;
    padding-right:5px;
    //padding-bottom: 70px;
    //margin-bottom: 40px;
    width: 100%;//300px;
    resize:none;
    text-align: right;
  }
  .dialog-input-field-explain-alt
  {
    height:40px;
    vertical-align: middle;
    background-color:#343F68;
    color:white;
    padding-left:5px;
    padding-right:5px;
    //padding-bottom: 70px;
    //margin-bottom: 40px;
    width: 100%;//300px;
    resize:none;
    text-align: right;
  }
  .dialog-input-button
  {
    height:50px;
    vertical-align: middle;
    background-color:#775C9F;
    color:white;
    border-radius: 10px;
    border-width: 1px;
    border-color:darkgray;
  }
  /* .mood
  {
    padding-right:25px;
    color:white;
    text-align: right;
    background-color:#343F68;
  } */
  
  .entry
  {
    width:100%;
    color:white;
    background-color:#343F68;
    text-align: center;
  }
  .toggleBreak{
    display: none;
  }
  .statement
  {
    width:100%;
    margin:0 auto;
  }
  #mood-2
  {
    width:100%;
    color:white;
    background-color:#343F68;
  }
  // END TABLE STYLES

  // BEGIN DOT STYLES
 /* .border-dots
 {
    //border-bottom-style:none;
    border-bottom-style:dashed;
    border-bottom-width:1px !important;
    border-bottom-color:lightgray;//#4682B4 !important;
 } */
 .border-dots
 {
    border-bottom-style:dashed;
    border-bottom-width:1px !important;
    border-bottom-color:#4682B4 !important;
 }
 .border-dots-inner
 {
    border-bottom-style:none;
 }
 // END DOT STYLES
 
 // BEGIN CORNER STYLES
 .radius-single-left-field-left-top
  {
    border-top-left-radius:15px;
    overflow:hidden;
  }
  .radius-single-left-field-left-bottom
  {
    //border-bottom-left-radius:15px;
    overflow:hidden;
  } 
 .radius-single-left-field-right-top
  {
    border-top-right-radius:15px;
    overflow:hidden;
  }
  .radius-single-left-field-right-bottom
  {
    //border-bottom-right-radius:15px;
    overflow:hidden;
  }
  .radius-single-right-field-left-top
  {
    //border-top-left-radius:15px;
    overflow:hidden;
  }
  .radius-single-right-field-left-bottom
  {
    border-bottom-left-radius:15px;
    overflow:hidden;
  }
  .radius-single-right-field-right-top
  {
    //border-top-right-radius:15px;
    overflow:hidden;
  }
  .radius-single-right-field-right-bottom
  {
    border-bottom-right-radius:15px;
    overflow:hidden;
  }

  // TOP ROW
  .radius-top-left-field-top
  {
    border-top-left-radius:15px;
    overflow:hidden;
  }
  .radius-top-left-field-bottom
  {
    //border-bottom-left-radius:15px;
    overflow:hidden;
  } 
  .radius-top-right-field-top
  {
    border-top-right-radius:15px;
    overflow:hidden;
  }
  .radius-top-right-field-bottom
  {
    //border-bottom-right-radius:15px;
    overflow:hidden;
  } 

  // BOTTOM ROW
  .radius-bottom-left-field-top
  {
    //border-top-left-radius:15px;
    overflow:hidden;
  }
  .radius-bottom-left-field-bottom
  {
    border-bottom-left-radius:15px;
    overflow:hidden;
  } 
  .radius-bottom-right-field-top
  {
    //border-top-right-radius:15px;
    overflow:hidden;
  }
  .radius-bottom-right-field-bottom
  {
    border-bottom-right-radius:15px;
    overflow:hidden;
  } 

  // END CORNER STYLES

  // BEGIN OTHER STYLES
  .wrap
  {
    word-wrap:break-word !important;
    white-space: normal;
  }
  .col4-width
  {
    width:100% !important;
  }
  #main-table-row3
  {
    height:30px;
  }
  #country select
  {
    width:100px
  }
  #country select:focus
  {
    width:auto;
  }
  // END OTHER STYLES
  
  // BEGIN FOOTER STYLES
  .section-footer
  {
    height:10px;
    background-color:#343F68;
    color:white;
    vertical-align:top;
    //width:100%;
  }
  // END FOOTER STYLES

}

//////////////////////////////////////////
// DESKTOP
@media screen and (min-width:1024px)  
{
  
  #main-table-screen
  {
    width:100%;
    max-width:100%;
    min-width:100%;
    background-color:gray;
    padding: 0px;
    margin: 0px;
    margin-bottom:0px;
    display:table;    
  }
  #main-table-row1
  {
    height:50px; 
  }
  #main-table-row2-dialog-container-td
  {
    margin:auto;
  }
  // BEGIN TABLE STYLES
  .dialog-table
  {
    width:98%;
  }
  .dialog-table-half-width
  {
    width:50%;
  }
  .dialog-table-half-l
  {
    width:99%;
    margin-right: 1%;
  }
  .dialog-table-half-r
  {
    width:99%;
    margin-left: 1%;
  }
  #dialog-td-title
  {
    width:20%;
    height:100px;
    background-color:#4682B4;
    color:white;
    font-family:'Arial Black';
    font-size: 17pt;
    font-style:italic;
    font-weight: bold;
    padding-bottom:0px;
    margin-bottom:0px;
    vertical-align: middle; 
    text-align: center;  
  }
  #dialog-td-instructions
  {
    word-wrap:break-word !important;
    background-color:#4682B4;
    color:white;
    font-family:'Arial';
    font-size: 11pt;
    font-style:italic;
    padding-left:30px;
    padding-right:30px;
    vertical-align: middle;
  }
  .dialog-signon-td-section-title
  { 
    width:100%;
    height:35px;
    background-color:darkgray;
    color:white;
    font-family:'Arial Black';
    font-size: 17pt;
    font-style:italic;
    font-weight: bold;
    padding-bottom:0px;
    margin-bottom:0px;
    vertical-align: bottom;
    text-align: center;
  }
  .dialog-question-space
  {
    width:15px;
    background-color:#343F68;
    color:white;
  }
  .dialog-question-space-alt
  {
    width:15px;
    background-color:#19274D;//#666E9B;
    color:white;
  }
  .dialog-question
  {
    height:25px;
    vertical-align: middle;
    background-color:#343F68;
    color:white;
    word-wrap:break-word !important;
  }
  .dialog-input-field-right
  {
    width:15%; //width="10%"
    height:25px;
    vertical-align: top;
    background-color:#343F68;
    color:white;
    text-align: right;
    padding-right:25px;
  }
  .dialog-input-field-right-alt
  {
    width:15%; //width="10%"
    height:25px;
    vertical-align: top;
    background-color:#19274D;//#666E9B;
    color:white;
    text-align: right;
    padding-right:25px;
  }
  .dialog-sub-question
  {
    background-color:#343F68;
    color:white;
    vertical-align:top;
  }
  .dialog-sub-question-alt
  {
    background-color:#19274D;//#666E9B;
    color:white;
    vertical-align:top;
  }
  .dialog-sub-question-div
  {
    width:25px;
  }

  .dialog-input-field-explain
  {
    height:100px;
    vertical-align: middle;
    background-color:#343F68;
    color:white;
    padding-right:25px;
    padding-top:5px;
    width:25%;
    resize:vertical;
    text-align: right;
  }
  .dialog-input-field-explain-alt
  {
    height:100px;
    vertical-align: middle;
    background-color:#19274D;
    color:white;
    padding-right:25px;
    padding-top:5px;
    width:25%;
    resize:vertical;
    text-align: right;
  }
  .dialog-input-button
  {
    height:50px;
    vertical-align: middle;
    background-color:#775C9F;
    color:white;
    border-radius: 10px;
    border-width: 1px;
    border-color:darkgray;
  }
  /* .mood
  {
    //padding-right:25px;
    color:white;
    text-align: center;
    background-color:#343F68;
  } */
 
  .entry
  {
    width:100%;
    color:white;
    background-color:#343F68;
    text-align: center;
  }
  .toggleBreak{
    display: inline;
  }
  .statement
  {
    width:95%;
    margin:0 auto;
  }
  #mood-2
  {
    width:66%;
    color:white;
    background-color:#343F68;
  }
  // END TABLE STYLES

  // BEGIN DOT STYLES
  .border-dots
  {
      border-bottom-style:dashed;
      border-bottom-width:1px !important;
      border-bottom-color:#4682B4 !important;
  }
 
  .border-dots-inner
  {
      border-bottom-style:dashed;
      border-bottom-width:1px !important;
      border-bottom-color:#4682B4 !important;
  }

  // END DOT STYLES
  
  // BEGIN CORNER STYLES
 .radius-single-left-field-left-top
  {
    border-top-left-radius:15px;
    overflow:hidden;
  }
  .radius-single-left-field-left-bottom
  {
    border-bottom-left-radius:15px;
    overflow:hidden;
  } 
 .radius-single-left-field-right-top
  {
    //border-top-right-radius:15px;
    overflow:hidden;
  }
  .radius-single-left-field-right-bottom
  {
    //border-bottom-right-radius:15px;
    overflow:hidden;
  }

  .radius-single-right-field-left-top
  {
    //border-top-left-radius:15px;
    overflow:hidden;
  }
  .radius-single-right-field-left-bottom
  {
    //border-bottom-left-radius:15px;
    overflow:hidden;
  }
  .radius-single-right-field-right-top
  {
    border-top-right-radius:15px;
    overflow:hidden;
  }
  .radius-single-right-field-right-bottom
  {
    border-bottom-right-radius:15px;
    overflow:hidden;
  }

  // TOP ROW
  .radius-top-left-field-top
  {
    border-top-left-radius:15px;
    overflow:hidden;
  }
  .radius-top-left-field-bottom
  {
    //border-bottom-left-radius:15px;
    overflow:hidden;
  } 
  .radius-top-right-field-top
  {
    border-top-right-radius:15px;
    overflow:hidden;
  }
  .radius-top-right-field-bottom
  {
    //border-bottom-right-radius:15px;
    overflow:hidden;
  } 


  // BOTTOM ROW
  .radius-bottom-left-field-top
  {
    //border-top-left-radius:15px;
    overflow:hidden;
  }
  .radius-bottom-left-field-bottom
  {
    border-bottom-left-radius:15px;
    overflow:hidden;
  } 
  .radius-bottom-right-field-top
  {
    //border-top-right-radius:15px;
    overflow:hidden;
  }
  .radius-bottom-right-field-bottom
  {
    border-bottom-right-radius:15px;
    overflow:hidden;
  } 

  // END CORNER STYLES
  
  // BEGIN OTHER STYLES  
  .wrap
  {
    word-wrap:break-word !important;
  }
  .col4-width
  {
    width:75% !important;
  }
  #main-table-row3
  {
    height:30px;
  }
  #country select
  {
    width:100px
  }
  #country select:focus
  {
    width:auto;
  }
  // END OTHER STYLES
  
  // BEGIN FOOTER STYLES
  .section-footer
  {
    height:20px;
    background-color:#343F68;
    color:white;
    vertical-align:top;
    width:50%;
  }
  // END FOOTER STYLES
}
</style>